import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routes } from '../routes';
import { useLanguageContext } from '../context/LanguageContext';

const RoutesWrapper = ({ children }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { lastLanguageChange, setLastLanguageChange } = useLanguageContext();

  useEffect(() => {
    const { pathname } = window.location;

    document.documentElement.lang = i18n.language;

    if (lastLanguageChange) {
      if (pathname.startsWith('/en')) i18n.changeLanguage('en');
      else i18n.changeLanguage('es');
      setLastLanguageChange(false);  // Evitamos cambios múltiples rápidamente
    }

    // Caso especial: si la ruta es "/", redirigir a "/en" o "/es" según el idioma
    if (pathname === '/') {
      const defaultLang = i18n.language === 'en' ? '/en' : '/';
      navigate(defaultLang, { replace: true });
      return;
    }

    // Caso especial: si la ruta es "/en", redirigir a "/"
    if (pathname === '/en' && i18n.language !== 'en') {
      navigate('/', { replace: true });
      return;
    }

    // Eliminar la barra diagonal extra si está al final de la ruta
    if (pathname.endsWith('/')) {
      navigate(pathname.slice(0, -1), { replace: true });
      return;
    }

    // Verificar si la ruta comienza con "/en" (para inglés)
    const isEnglish = pathname.startsWith('/en');
    const newLanguagePrefix = i18n.language === 'en' ? '/en' : '';

    // Base path, eliminamos "/en" si es inglés
    const basePath = isEnglish ? pathname.replace(/^\/en/, '') : pathname;

    const currentRoute = isEnglish
      ? routes.en.find((route) => route.path.includes(basePath))
      : routes.es.find((route) => route.path.includes(basePath));

    // Buscar la ruta equivalente en el otro idioma
    const translatedPath =
      (i18n.language === 'en'
        ? routes.en.find((route) => route.id === currentRoute?.id)?.path
        : routes.es.find((route) => route.id === currentRoute?.id)?.path) ||
      `${newLanguagePrefix}${basePath}`;

    // Redirigir solo si la ruta traducida no es la misma que la actual
    if (translatedPath !== pathname && translatedPath !== basePath) {
      navigate(translatedPath, { replace: true });
    }
  }, [i18n.language, navigate, lastLanguageChange, setLastLanguageChange, i18n]);

  return <>{children}</>;
};

export default RoutesWrapper;
